export default {
  websock: null,
  clienId: null,
  isConnect: false // websocket连接状态
}